import React, { useState, useEffect, lazy, Suspense } from "react";
import { Routes, Route, useLocation } from "react-router-dom";
import GlobalCursor from "../components/globalcursor/GlobalCursor";

import SummerTrainingPopup from "../components/pop-up/TrainingPopup";


/* ALWAYS LOAD (not lazy) */
import Navbar from "../widgets/navbar/Navbar";
import Footer from "../widgets/footer/Footer";
import Loader from "../loader/Loader";
import Meta from "../Meta";
import FuturePost from "../components/featuredPosts/FeaturedPosts"

/* LAZY LOAD PAGES & SECTIONS */
const Carousel = lazy(() => import("../carousel/Carousel"));
const Home = lazy(() => import("../pages/home/Home"));
const SoftwareCompany = lazy(() =>
  import("../pages/home/softwarecompany/SoftwareCompany")
);
const Technologies = lazy(() =>
  import("../pages/home/technologies/Technologies")
);
const RecentProject = lazy(() =>
  import("../pages/home/projects/RecentProject")
);
const Testimonials = lazy(() =>
  import("../pages/home/testimonial/Testimonials")
);
const Vision = lazy(() => import("../pages/home/vision/Vision"));

const About = lazy(() => import("../pages/about/About"));
const Founders = lazy(() =>
  import("../pages/about/founders/Founders")
);
const Service = lazy(() => import("../pages/services/Service"));
const Hfaq = lazy(() => import("../components/faq/Hfaq"));
const ContactDetail = lazy(() =>
  import("../pages/contact/ContactDetail")
);

const WebDesign = lazy(() =>
  import("../components/webdesign/WebDesign")
);
const Webdevelop = lazy(() =>
  import("../components/webdeveloper/Webdevelop")
);
const Mobiledev = lazy(() =>
  import("../components/mobiledevloper/Mobiledev")
);
const Seo = lazy(() => import("../components/seo/SEO"));
const Software = lazy(() =>
  import("../components/SoftwareTrainng/SoftwareTraining")
);
const UiWeb = lazy(() =>
  import("../components/trainingcomponents/TwebDesign")
);
const FrontEnd = lazy(() =>
  import("../components/trainingcomponents/TfrontendDevelopment")
);
const BackEnd = lazy(() =>
  import("../components/trainingcomponents/TbackendDevelopment")
);
const FullSack = lazy(() =>
  import("../components/trainingcomponents/TfullstackDevelopment")
);
const Mobile = lazy(() =>
  import("../components/trainingcomponents/TmobileAppDevelopment")
);
const Data = lazy(() =>
  import("../components/trainingcomponents/TdataSciencesDevelopment")
);
const Dsa = lazy(() =>
  import("../components/trainingcomponents/TdsaDevelopment")
);
const Digital = lazy(() =>
  import("../components/trainingcomponents/TseoDevelopment")
);

const Career = lazy(() => import("../pages/career/Career"));
const Careerfill = lazy(() =>
  import("../pages/career/careerfill/Careerfill")
);
const Blog = lazy(() => import("../pages/Blog/Blog"));
const Contact = lazy(() => import("../pages/contact/Contact"));

const DetailsTechnologies = lazy(() =>
  import(
    "../pages/home/technologies/detailstechnologies/DetailsTechnologies"
  )
);

const CustomSoftware = lazy(() =>
  import("../components/customsoftware/CustomSoftware")
);
const AiDevelopar = lazy(() =>
  import("../components/aideveloper/AiDevelopar")
);
const Cloud = lazy(() =>
  import("../components/cloud/Cloud")
);
const Testing = lazy(() =>
  import("../components/test/Testing")
);
const Ecommerce = lazy(() =>
  import("../components/ecommerce/Ecommerce")
);
const ReDesign = lazy(() =>
  import("../components/againdesign/ReDesign")
);
const Maintenance = lazy(() =>
  import("../components/maintenance/Maintenance")
);



/* Scroll to top on route change */
function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, [pathname]);

  return null;
}

/* Meta re-renderer */
function MetaUpdater() {
  const location = useLocation();
  return <Meta key={location.pathname} />;
}

export default function App() {
  const [loading, setLoading] = useState(true);
    const location = useLocation();

  useEffect(() => {
    const timer = setTimeout(() => setLoading(false), 800);
    return () => clearTimeout(timer);
  }, []);

  return (
    <>
      {loading && <Loader show={true} />}

      {!loading && (
        <div className="App">
          <GlobalCursor />
          <ScrollToTop />
          <Navbar />
          <MetaUpdater />
                   {/* Popup only homepage */}
      {location.pathname === "/" && <SummerTrainingPopup />}

          {/* LAZY ROUTES */}
          <Suspense fallback={<Loader show={true} />}>
            <Routes>
              <Route
                path="/"
                element={
                  <>
                    <Carousel />
                    <FuturePost />
                    <Home />
                    <Service />
                    <Vision />
                    <SoftwareCompany />
                    <Technologies />
                    <RecentProject />
                    <Testimonials />
                    <Hfaq />
                    <Contact />
                  </>
                }
              />

              <Route
                path="/about-us"
                element={
                  <>
                    <About />
                    <Founders />
                  </>
                }
              />

              <Route path="/services" element={<Service />} />
              <Route path="/web-design" element={<WebDesign />} />
              <Route
                path="/web-development-service-company-lucknow"
                element={<Webdevelop />}
              />
              <Route
                path="/mobile-app-development-2"
                element={<Mobiledev />}
              />
              <Route path="/seo-lucknow" element={<Seo />} />
              <Route path="/contactus" element={<ContactDetail />} />
              <Route path="/career" element={<Career />} />
              <Route path="/careerfill" element={<Careerfill />} />
              <Route path="/blogs" element={<Blog />} />
              <Route path="/software-training" element={<Software />} />
              <Route path="/uiux-training" element={<UiWeb />} />
              <Route path="/frontend-training" element={<FrontEnd />} />
              <Route path="/backend-training" element={<BackEnd />} />
              <Route path="/fullstack-training" element={<FullSack />} />
              <Route path="/mobile-app-training" element={<Mobile />} />
              <Route path="/dsa-training" element={<Dsa />} />
              <Route path="/seo-digital-training" element={<Digital />} />
              <Route path="/data-science-training" element={<Data />} />

              <Route path="/contact" element={<Contact />} />
              <Route
                path="/technologies"
                element={<DetailsTechnologies />}
              />
              <Route
                path="/custom-software"
                element={<CustomSoftware />}
              />
              <Route
                path="/ai-software-development-services"
                element={<AiDevelopar />}
              />
              <Route
                path="/cloud-and-devops"
                element={<Cloud />}
              />
              <Route
                path="/testing-qa"
                element={<Testing />}
              />
              <Route path="/ecommerce-website-development" element={<Ecommerce />} />
              <Route path="/website-redesign" element={<ReDesign />} />
              <Route path="/maintenance-services" element={<Maintenance />} />
            </Routes>
          </Suspense>
          <Footer />
        </div>
      )}
    </>
  );
}
